import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin.component';
import { OrganizationComponent } from './pages/organization/organization.component';
import { ConfigComponent } from './pages/config/config.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { LanguageComponent } from './pages/language/language.component';
import { LogComponent } from './pages/log/log.component';
import { UserComponent } from './pages/user/user.component';
import { DepartmentsComponent } from './pages/departments/departments.component';
import { RolesComponent } from './pages/roles/roles.component';
import { UserAccessComponent } from './pages/user-access/user-access.component';
import { UserAddEditComponent } from './pages/user/user-add-edit/user-add-edit.component';
import { DepartmentAddEditComponent } from './pages/departments/department-add-edit/department-add-edit.component';
import { RoleAddEditComponent } from './pages/roles/role-add-edit/role-add-edit.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'organizations', component: OrganizationComponent },
      { path: 'config', component: ConfigComponent },
      { path: 'categories', component: CategoriesComponent },
      { path: 'language', component: LanguageComponent },
      { path: 'log', component: LogComponent },
      { path: 'users', component: UserComponent },
      { path: 'users/add', component: UserAddEditComponent },
      { path: 'users/edit/:id', component: UserAddEditComponent },
      { path: 'departments', component: DepartmentsComponent },
      { path: 'departments/add', component: DepartmentAddEditComponent },
      { path: 'departments/edit/:id', component: DepartmentAddEditComponent },
      { path: 'roles', component: RolesComponent },
      { path: 'roles/add', component: RoleAddEditComponent },
      { path: 'roles/edit/:id', component: RoleAddEditComponent },
      { path: 'user-access', component: UserAccessComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
